import { render, staticRenderFns } from "./repaymentInpt.vue?vue&type=template&id=489a1f64&scoped=true"
import script from "./repaymentInpt.vue?vue&type=script&lang=js"
export * from "./repaymentInpt.vue?vue&type=script&lang=js"
import style0 from "./repaymentInpt.vue?vue&type=style&index=0&id=489a1f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489a1f64",
  null
  
)

export default component.exports